import React from "react";
import { generateCRUDRoutes } from "../../../utils/index";

import Profile from "./index";
import { User } from "lucide-react";

const profileRoutes = [	
    generateCRUDRoutes({
        mainTitle: "My Profile",
        basePath: "profiles",
        mainComponent: <Profile />,
        isMainMenu:false,
        layout: "/console",
        icon: <User className="icon-item" />,
        subTitle:"Profile",
        level:5,
        moduleId: 0,
    })

]

export default profileRoutes;